export const ADMIN_WELCOME_PATH = '/welcome'
